module.exports = __webpack_public_path__ + "static/media/BMODE_f6c8862b-b0cf-4597-b40a-038c353b1d4d.bad56770.jpg";